const params = () => new URLSearchParams(window.location.search)
const pageId = () =>
  window.location.pathname
    .split('/')
    .slice(-1)
    .pop()

export default {
  getUrlParam: key => params().get(key),
  hasUrlParams: () => Array.from(params()).length > 0,
  getPageId: () => pageId(),
}
